<app-dialog
  [dialogTitle]="'public.checkout.savedVouchers' | translate"
  (keydown)="onKeyDown($event)"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="'public.checkout.savedVouchers' | translate"
>
  <app-dialog-content>
    <div class="voucher-selection-content">
      <div
        class="voucher-list"
        *ngIf="!isLoading"
        [ngClass]="{ 'voucher-list-empty': !voucherOptions.length }"
      >
        <ng-container *ngIf="voucherOptions.length; else noVouchers">
          <form [formGroup]="voucherForm" class="voucher-form">
            <app-radio-group
              formControlName="selectedVoucher"
              name="voucher"
              [options]="voucherOptions"
              role="radiogroup"
              [attr.aria-label]="'public.checkout.selectVoucher' | translate"
            >
              <ng-template #optionContent let-option>
                <div class="check-terms pl-3">
                  <div class="d-flex align-items-center ml-3">
                    <span class="voucher-icon mr-2" aria-hidden="true">
                      <i [class]="option.cardIcon || 'fas fa-tag'"></i>
                    </span>

                    <span class="voucher-text">
                      {{ option.cardLabel }}
                    </span>
                  </div>
                </div>
              </ng-template>
            </app-radio-group>
          </form>

          <app-button
            type="button"
            variant="none"
            classes="manage-vouchers-link"
            *ngIf="showManageVouchersLink"
            (click)="onManageVouchers()"
            [attr.aria-label]="'public.profile.myVouchersTitle' | translate"
          >
            <i class="fas fa-gear" aria-hidden="true"></i>
            <span>{{ 'public.profile.myVouchersTitle' | translate }}</span>
          </app-button>
        </ng-container>

        <ng-template #noVouchers>
          <div class="no-vouchers-state" role="status" aria-live="polite">
            <div class="no-vouchers-icon theme-color-header" aria-hidden="true">
              <app-icon icon="fas fa-tag"></app-icon>
            </div>
            <div class="no-vouchers-text theme-color-header">
              {{ 'public.checkout.noSavedVouchers' | translate }}
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </app-dialog-content>

  <app-dialog-actions>
    <app-button
      variant="secondary"
      (click)="onCancel()"
      [attr.aria-label]="'public.dialog.cancel' | translate"
    >
      {{ 'public.dialog.cancel' | translate }}
    </app-button>

    <app-button
      *ngIf="voucherOptions.length"
      variant="dark"
      size="small"
      (click)="onApply()"
      [disabled]="!hasSelectedVoucher"
      [attr.aria-label]="'public.action.apply' | translate"
    >
      {{ 'public.action.apply' | translate }}
    </app-button>
  </app-dialog-actions>

  <app-loading-panel
    [showLoading]="isLoading"
    [hideText]="true"
    [isSmall]="true"
    [variant]="'overlay'"
    role="status"
    [attr.aria-label]="'public.global.loading' | translate"
  />
</app-dialog>
